import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./style.module.scss";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import logo from "../../assets/image/Frame.png";
import noImg from "../../assets/image/noimage.jpg";
import doc from "../../assets/image/document.png";
import close from "../../assets/image/delete.png";
// import on from "../../assets/image/on.png";
// import off from "../../assets/image/off.png";
// import chevron from "../../assets/image/chevron.png";

// import checkService from "../../helpers/checkService";

import { MainContext } from "../../context/MainContext";

import { Switch, TextField, Button, Box, List, ListItem } from "@mui/material";
import { styled } from "@mui/material/styles";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

import {
  setChangeSystem,
  setChangeFaults,
  setPdfFile,
  setFile,
  getLinkFile,
  deleteFile,
} from "../../controllers/APIDataCallController/APIDataCallController";

import SlideCurrentFaults from "../../components/ComponentsObjectPage/SlideCurrentFaults";
import SlideArchiveFaults from "../../components/ComponentsObjectPage/SlideArchiveFaults";
import PdfGenerator from "../../components/ComponentsObjectPage/PdfGenerator";

import Skeleton from "@mui/material/Skeleton";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { PDFDocument } from "pdf-lib";

// import { Viewer, Worker, Document, Page } from "@react-pdf-viewer/core";
// import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
// import "@react-pdf-viewer/core/lib/styles/index.css";
// import "@react-pdf-viewer/default-layout/lib/styles/index.css";

function Objects() {
  const navigate = useNavigate();
  const { markers, fetchFaults, setMarkers, setFetchFaults, user, fetchPdf, setFetchPdf, setArchive } =
    useContext(MainContext);

  const [elemMarker, setElemMarker] = useState();
  const [openMenu, setOpenMenu] = useState(false);
  const [menuType, setMenuType] = useState("");
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [selectedFault, setSelectedFault] = useState(null);
  const [valueSearch, setValueSearch] = useState("");

  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState([]);

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertValue, setAlertValue] = useState("");

  const [images, setImages] = useState([]);
  const [imagesValue, setImagesValue] = useState("");
  const [files, setFiles] = useState();
  const [filesValue, setFilesValue] = useState("");
  const [switchStates, setSwitchStates] = useState(true);

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [fileName, setFileName] = useState(null);
  const [delPdfFile, setDelPdfFile] = useState(null);

  const faultsRef = useRef([]);
  const removedFaultsRef = useRef([]);
  const removedCurrentFaultsRef = useRef([]);
  const valueRef = useRef({});

  const RedSwitch = styled(Switch)({
    "& .Mui-checked": {
      color: "#d32f2f !important",
    },
    "& .Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#d32f2f !important",
    },
  });

  useEffect(() => {
    !alertOpen
      ? setAlertValue("")
      : setTimeout(() => {
          setAlertOpen(!alertOpen);
        }, 5000);
  }, [alertOpen]);

  useEffect(() => {
    if (!fileName) {
      setFileName(null);
      setDelPdfFile(null);
    }
  }, [fileName]);

  useEffect(() => {
    if (selectedMarker) {
      const selectedLength = selectedMarker.to.split(", ");
      setSelected([...Array(selectedLength.length).keys()]);
      setItems(selectedMarker.to.split(", ").map((label) => ({ label, checked: true })));
    }
  }, [selectedMarker]);

  useEffect(() => {
    const search = valueSearch.toLowerCase();

    const sortedMarkers = [...markers].sort((a, b) => a.id - b.id);

    const filteredMarkers = sortedMarkers.filter(
      (item) =>
        item.name.toLowerCase().includes(search) ||
        item.address.toLowerCase().includes(search) ||
        item.id.toString().includes(search)
    );

    setElemMarker(filteredMarkers);
  }, [valueSearch, markers]);

  useEffect(() => {
    if (!openMenu) {
      setMenuType("");
      setSelectedMarker(null);
      setItems([]);
      setSelected([]);
      setSelectedFault(null);
      setImages([]);
      setImagesValue("");
      setFiles(null);
      setFilesValue("");
      faultsRef.current = [];
      valueRef.current = [];
      removedCurrentFaultsRef.current = [];
    } else {
      setAlertOpen(false);
    }
  }, [openMenu]);

  const handleSavePDF = async () => {
    if (images.length === 0) {
      setAlertOpen(!alertOpen);
      setAlertValue("Добавьте хотя бы одно фото!");
      return;
    }

    if (imagesValue === "") {
      setAlertOpen(!alertOpen);
      setAlertValue("Добавьте название Файла");
      return;
    }

    const pdfDoc = await PDFDocument.create();
    for (const imgUrl of images) {
      const res = await fetch(imgUrl);
      const imgBytes = await res.arrayBuffer();

      const contentType = res.headers.get("content-type")?.toLowerCase() || "";
      let img;

      if (contentType.includes("png") || imgUrl.toLowerCase().endsWith(".png")) {
        img = await pdfDoc.embedPng(imgBytes);
      } else if (
        contentType.includes("jpeg") ||
        contentType.includes("jpg") ||
        imgUrl.toLowerCase().match(/\.(jpg|jpeg)$/)
      ) {
        img = await pdfDoc.embedJpg(imgBytes);
      } else {
        setAlertOpen(!alertOpen);
        setAlertValue(
          `Формат не поддерживается:\n${contentType}\n \nИспользуйте следующие форматы изображений: png, jpg, jpeg`
        );
        return;
      }

      const page = pdfDoc.addPage([img.width, img.height]);
      page.drawImage(img, { x: 0, y: 0, width: img.width, height: img.height });
    }

    // for (const imgUrl of images) {
    //   const imgBytes = await fetch(imgUrl).then((res) => res.arrayBuffer());
    //   const img = await pdfDoc.embedJpg(imgBytes);
    //   const page = pdfDoc.addPage([img.width, img.height]);
    //   page.drawImage(img, { x: 0, y: 0, width: img.width, height: img.height });
    // }

    const pdfBytes = await pdfDoc.save();
    const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });

    const formData = new FormData();

    formData.append("pdf", pdfBlob, "document.pdf");
    formData.append("user", JSON.stringify(user));
    formData.append("selectedMarker", JSON.stringify(selectedMarker));
    formData.append("value", imagesValue);

    await setPdfFile(formData, setFetchPdf);
  };

  const handleSaveFile = async () => {
    if (!files) {
      setAlertOpen(!alertOpen);
      setAlertValue("Добавьте хотя бы один файл!");
      return;
    } else {
      const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "text/plain",
      ];
      if (!allowedTypes.includes(files.type)) {
        setAlertOpen(!alertOpen);
        setAlertValue("Разрешены только файлы PDF, DOC, DOCX или TXT");
        return;
      }
    }

    if (filesValue === "") {
      setAlertOpen(!alertOpen);
      setAlertValue("Добавьте название Файла");
      return;
    }

    const formData = new FormData();

    formData.append("file", files);
    formData.append("user", JSON.stringify(user));
    formData.append("selectedMarker", JSON.stringify(selectedMarker));
    formData.append("value", filesValue);

    await setFile(formData, setFetchPdf);
  };

  const handleGetLinkFile = (publicUrl, item) => {
    getLinkFile(user, item, publicUrl);
  };

  const handleRemovePDF = (item, marker) => {
    setFileName(item);
    setDelPdfFile(marker);
    setOpenDeleteDialog(!openDeleteDialog);
  };

  const DeletePDFFile = async () => {
    await deleteFile(user, fileName, delPdfFile, setFetchPdf);
    setOpenDeleteDialog(false);
  };

  const handleToggle = (index, event) => {
    setItems(
      items.map((item, i) =>
        i === index ? { label: item.label, checked: event.target.checked } : item
      )
    );
    setSelected((prev) => {
      const newSelected = prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index];
      return newSelected;
    });
  };

  const handleAddItem = () => {
    setItems([...items, { label: "", checked: false }]);
  };

  const handleLabelChange = (index, value) => {
    setItems((prev) => {
      const newItems = [...prev];
      newItems[index].label = value;
      return newItems;
    });
  };

  const handleChangeMenu = (marker) => {
    setSelectedMarker(marker);
    setOpenMenu(!openMenu);
  };

  const handleOpenMenuFaults = (fault) => {
    setSelectedFault(fault);
  };

  const handleSave = async () => {
    if (menuType === "systems") {
      await setChangeSystem(user, selectedMarker, setMarkers, items, setArchive);
    } else if (menuType === "faults") {
      removedCurrentFaultsRef.current = removedCurrentFaultsRef.current.map((e) => {
        if (valueRef.current[e.fault_id]) {
          return { ...e, fix_notes: valueRef.current[e.fault_id] };
        }
        return e;
      });

      if (faultsRef.current.length === 0 && removedCurrentFaultsRef.current.length === 0) {
        setAlertOpen(!alertOpen);
        setAlertValue("Нет данных для Сохранения");
      } else if (
        (faultsRef.current.length > 0 &&
          faultsRef.current.some((item) => item.system === "" || item.fault === "")) ||
        (removedCurrentFaultsRef.current.length > 0 &&
          removedCurrentFaultsRef.current.some((item) => item.fix_notes === ""))
      ) {
        setAlertOpen(!alertOpen);
        setAlertValue("Заполните все поля перед Сохранением");
      } else {
        setChangeFaults(
          user,
          selectedMarker,
          faultsRef.current,
          removedCurrentFaultsRef.current,
          setFetchFaults
        );
      }

      faultsRef.current = [];
      valueRef.current = [];
      removedCurrentFaultsRef.current = [];
    } else if (menuType === "document") {
      if (switchStates) {
        handleSavePDF();
      } else {
        handleSaveFile();
      }
    }

    setMenuType("");
    setItems([]);
    setSelected([]);
    setSelectedMarker(null);
    setImages([]);
    setImagesValue([]);
    setFiles(null);
    setFilesValue("");
    setOpenMenu(false);
  };

  const slideTemplates = [
    ({ marker }) => (
      <div className={styles.objects__slide_templates}>
        <h2 className={styles.objects__slide_templates__title}>Технические осмотры</h2>
        <div style={{ overflow: "auto", height: "200px" }}>
          {marker.all_to.map((to, index) => (
            <p className={styles.objects__card__item__base_info__text} key={index}>
              {to}
            </p>
          ))}
        </div>
      </div>
    ),
    ({ marker }) => (
      <div className={styles.objects__slide_templates}>
        <div className={styles.objects__slide_templates__btn__wrapper}>
          <h2 className={styles.objects__slide_templates__btn__title}>Системы:</h2>
          <button
            className={styles.objects__slide_templates__btn}
            onClick={() => {
              handleChangeMenu(marker);
              setMenuType("systems");
            }}
          >
            + изменить
          </button>
        </div>
        <p className={styles.objects__card__item__base_info__text}>{marker.to}</p>
      </div>
    ),
    ({ marker, fault }) => (
      <div className={styles.objects__slide_templates}>
        <div className={styles.objects__slide_templates__btn__wrapper}>
          <h2 className={styles.objects__slide_templates__btn__title}>Неисправности</h2>
          <button
            className={styles.objects__slide_templates__btn}
            onClick={() => {
              handleChangeMenu(marker);
              setMenuType("faults");
              handleOpenMenuFaults(fault);
            }}
          >
            + добавить / просмотреть
          </button>
        </div>
        {!fault || fault.current_faults.length === 0 ? (
          <p className={styles.objects__card__item__base_info__text}>The systems are working</p>
        ) : (
          <div className={styles.objects__slide_templates__faults}>
            {fault.current_faults.map((item, index) => (
              <div key={index} className={styles.objects__slide_templates__faults__wrapper}>
                <div className={styles.objects__slide_templates__faults__system}>
                  <p className={styles.objects__slide_templates__faults__text}>{item.system}</p>
                  <p className={styles.objects__slide_templates__faults__text}>
                    {item.reported_at}
                  </p>
                </div>
                <p className={styles.objects__slide_templates__faults__text}>{item.fault}</p>
                <span className={styles.objects__slide_templates__faults__border}></span>
              </div>
            ))}
          </div>
        )}
      </div>
    ),
    ({ marker, pdf }) => (
      <div className={styles.objects__slide_templates}>
        <div className={styles.objects__slide_templates__btn__wrapper}>
          <h2 className={styles.objects__slide_templates__btn__title}>Документация объекта</h2>
          <button
            className={styles.objects__slide_templates__btn}
            onClick={() => {
              handleChangeMenu(marker);
              setMenuType("document");
            }}
          >
            + добавить
          </button>
        </div>
        {pdf ? (
          <div className={styles.objects__slide_templates__document__wrapper}>
            {pdf.pdf.map((item, index) => (
              <div key={index} style={{ position: "relative" }}>
                <span
                  onClick={() => handleGetLinkFile(item.fileUrl, item)}
                  className={styles.objects__slide_templates__document}
                >
                  <img
                    className={styles.objects__slide_templates__document__img}
                    src={doc}
                    alt="doc"
                  />
                  <h2 className={styles.objects__slide_templates__document__text}>{item.value}</h2>
                </span>
                <img
                  className={styles.objects__slide_templates__document__close}
                  src={close}
                  alt="close"
                  onClick={() => {
                    handleRemovePDF(item, marker);
                  }}
                />
              </div>
            ))}
          </div>
        ) : (
          <p className={styles.objects__card__item__base_info__text}>In working</p>
        )}
      </div>
    ),
  ];

  const slideTemplatesFault = [
    () => (
      <div style={{ height: "100%" }}>
        <h3 className={styles.objects__menu__content__wrapper__faults__title}>
          Текущие неисправности
        </h3>
        <SlideCurrentFaults
          initialFaults={selectedFault?.current_faults}
          faultsRef={faultsRef}
          removedFaultsRef={removedFaultsRef}
          removedCurrentFaultsRef={removedCurrentFaultsRef}
          user={user}
          valueRef={valueRef}
          selectedFault={selectedFault}
        />
      </div>
    ),
    () => (
      <div style={{ height: "100%" }}>
        <h3 className={styles.objects__menu__content__wrapper__faults__title}>
          Архив неисправностей
        </h3>
        <SlideArchiveFaults selectedFault={selectedFault} />
      </div>
    ),
  ];

  return (
    <React.Fragment>
      <div className={styles.objects__banner}>
        <div className={styles.objects__banner__content}>
          <img className={styles.objects__banner__logo} src={logo} alt="logo" />
          <div>
            <h3 className={styles.objects__banner__content_title}>FIRE SAFETY</h3>
            <p className={styles.objects__banner__content_text}>Center</p>
          </div>
        </div>
        <div className={styles.objects__profile}>
          <button className={styles.objects__profile__btn} onClick={() => navigate("/")}>
            Return
          </button>
        </div>
        <div className={styles.objects__search__container}>
          <div className={styles.objects__search__box}>
            <svg
              className={styles.objects__search__icon}
              viewBox="0 0 24 24"
              fill="none"
              stroke="#c62828"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <input
              className={styles.objects__search__input}
              value={valueSearch}
              onChange={(e) => setValueSearch(e.target.value)}
              name="search"
              type="text"
              placeholder="Поиск..."
            />
          </div>
        </div>
      </div>

      <div className={styles.objects__card}>
        {elemMarker ? (
          elemMarker.map((marker) => (
            <div className={styles.objects__card__item} key={marker._id}>
              <div className={styles.objects__card__item__box}>
                <img
                  className={styles.objects__card__item__img}
                  src={marker.photo}
                  alt="img"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = noImg;
                  }}
                />
                <div className={styles.objects__card__item__box__title}>
                  <h3 className={styles.objects__card__item__box__text}>{marker.name}</h3>
                </div>
              </div>
              <div className={styles.objects__card__item__base_info}>
                <div className={styles.objects__card__item__base_info__box}>
                  <p className={styles.objects__card__item__base_info__text}>ID: {marker.id}</p>
                  <p className={styles.objects__card__item__base_info__text}>{marker.type}</p>
                </div>

                <p className={styles.objects__card__item__base_info__text}>{marker.address}</p>
                {marker.contact.name && marker.contact.tel && (
                  <>
                    <span className={styles.objects__card__item__base_info__text}>
                      Контактное лицо -
                      <span
                        className={styles.objects__card__item__base_info__text}
                        style={{ color: "#d32f2f", fontSize: "13px" }}
                      >
                        {" "}
                        {marker.contact.name}
                      </span>
                    </span>

                    <p className={styles.objects__card__item__base_info__text}>
                      +{marker.contact.tel}
                    </p>
                  </>
                )}
              </div>
              <div className={styles.objects__card__item__swiper}>
                <Swiper
                  modules={[Pagination]}
                  slidesPerView={1}
                  pagination={{
                    clickable: true,
                  }}
                  className={styles.objects__card__item__slider__swiper}
                  style={{ width: "100%" }}
                >
                  {slideTemplates.map((Slide, index) => (
                    <SwiperSlide key={index}>
                      <Slide
                        marker={marker}
                        fault={fetchFaults?.find((fault) => fault.object_id === marker.id)}
                        pdf={fetchPdf?.find((item) => item.object_id === marker.id)}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          ))
        ) : (
          <React.Fragment>
            <Card sx={{ mb: 2 }}>
              <CardHeader
                avatar={<Skeleton animation="wave" variant="circular" width={40} height={40} />}
                title={
                  <Skeleton animation="wave" height={10} width="80%" style={{ marginBottom: 6 }} />
                }
                subheader={<Skeleton animation="wave" height={10} width="40%" />}
              />
              <Skeleton sx={{ height: 190 }} animation="wave" variant="rectangular" />
              <CardContent>
                <React.Fragment>
                  <Skeleton animation="wave" height={10} style={{ marginBottom: 6 }} />
                  <Skeleton animation="wave" height={10} width="80%" />
                </React.Fragment>
              </CardContent>
            </Card>
            <Card sx={{ mb: 2 }}>
              <CardHeader
                avatar={<Skeleton animation="wave" variant="circular" width={40} height={40} />}
                title={
                  <Skeleton animation="wave" height={10} width="80%" style={{ marginBottom: 6 }} />
                }
                subheader={<Skeleton animation="wave" height={10} width="40%" />}
              />
              <Skeleton sx={{ height: 190 }} animation="wave" variant="rectangular" />
              <CardContent>
                <React.Fragment>
                  <Skeleton animation="wave" height={10} style={{ marginBottom: 6 }} />
                  <Skeleton animation="wave" height={10} width="80%" />
                </React.Fragment>
              </CardContent>
            </Card>
            <Card sx={{ mb: 2 }}>
              <CardHeader
                avatar={<Skeleton animation="wave" variant="circular" width={40} height={40} />}
                title={
                  <Skeleton animation="wave" height={10} width="80%" style={{ marginBottom: 6 }} />
                }
                subheader={<Skeleton animation="wave" height={10} width="40%" />}
              />
              <Skeleton sx={{ height: 190 }} animation="wave" variant="rectangular" />
              <CardContent>
                <React.Fragment>
                  <Skeleton animation="wave" height={10} style={{ marginBottom: 6 }} />
                  <Skeleton animation="wave" height={10} width="80%" />
                </React.Fragment>
              </CardContent>
            </Card>
          </React.Fragment>
        )}
      </div>

      <div className={`${styles.objects__menu} ${openMenu ? styles.objects__menu__open : ""}`}>
        <div style={{ width: "100%", textAlign: "center" }}>
          <button
            className={styles.objects__menu__btn_close}
            onClick={() => setOpenMenu(!openMenu)}
          />
        </div>
        {menuType === "systems" && (
          <div className={styles.objects__menu__content}>
            <h2 className={styles.objects__menu__content__title}>{selectedMarker.name}</h2>
            <div className={styles.objects__menu__content__wrapper}>
              <p className={styles.objects__menu__content__wrapper__text}>Системы</p>
              <p className={styles.objects__menu__content__wrapper__text}>Удалить / Добавить</p>
            </div>
            <Box sx={{ height: "100%", overflow: "auto" }}>
              <List>
                {items?.map((item, index) => (
                  <ListItem
                    key={index}
                    sx={{ display: "flex", alignItems: "center", paddingLeft: 0, paddingRight: 0 }}
                  >
                    <TextField
                      size="small"
                      value={item.label}
                      onChange={(e) => handleLabelChange(index, e.target.value)}
                      placeholder="Введите текст"
                      sx={{
                        flexGrow: 1,
                        mr: 2,
                        border: "1px solid #fff",
                        borderRadius: "5px",
                      }}
                    />
                    <RedSwitch
                      checked={selected.includes(index)}
                      onChange={(event) => handleToggle(index, event)}
                    />
                  </ListItem>
                ))}
              </List>
              <Button variant="contained" onClick={handleAddItem} fullWidth>
                + Добавить
              </Button>
            </Box>
          </div>
        )}
        {menuType === "faults" && (
          <div className={styles.objects__menu__content}>
            <h2 className={styles.objects__menu__content__title}>{selectedMarker.name}</h2>
            <div className={styles.objects__menu__content__wrapper__faults}>
              <div
                className={styles.objects__card__item__swiper}
                style={{ height: "100%", margin: 0, padding: 0 }}
              >
                <Swiper
                  modules={[Pagination]}
                  slidesPerView={1}
                  pagination={{
                    clickable: true,
                  }}
                  className={styles.objects__card__item__slider__faults}
                  style={{ width: "100%", height: "100%" }}
                >
                  {slideTemplatesFault.map((Slide, index) => (
                    <SwiperSlide key={index}>
                      <Slide />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        )}
        {menuType === "document" && (
          <PdfGenerator
            setImages={setImages}
            setImagesValue={setImagesValue}
            setFiles={setFiles}
            setFilesValue={setFilesValue}
            switchStates={switchStates}
            setSwitchStates={setSwitchStates}
          />
        )}
        <div className={styles.objects__menu__content__btn}>
          <Button
            variant="contained"
            onClick={handleSave}
            className={styles.objects__menu__content__btn__save}
          >
            Сохранить
          </Button>
          <Button
            variant="contained"
            onClick={() => setOpenMenu(false)}
            className={styles.objects__menu__content__btn__save}
          >
            Отменить
          </Button>
        </div>
      </div>

      {alertOpen && (
        <Alert
          sx={{
            position: "absolute",
            top: 50,
            left: 0,
            right: 0,
            width: "90%",
            margin: "0 auto",
            fontSize: 16,
            fontFamily: "Montserrat",
            zIndex: 2,
            alignItems: "center",
            whiteSpace: "pre-line",
          }}
          variant="filled"
          severity="error"
          onClose={() => {
            setAlertOpen(!alertOpen);
          }}
        >
          <AlertTitle sx={{ fontSize: 16, fontWeight: 900, fontFamily: "Montserrat" }}>
            Ошибка
          </AlertTitle>
          {alertValue}
        </Alert>
      )}

      {openDeleteDialog && (
        <React.Fragment>
          <Dialog
            open={openDeleteDialog}
            onClose={() => setOpenDeleteDialog(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">Предупреждение</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {`Вы действительно хотите удалить файл "${fileName?.value}"`}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenDeleteDialog(false)}>Отмена</Button>
              <Button onClick={DeletePDFFile} autoFocus>
                Удалить
              </Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default Objects;
